import * as constants from "./constants";

const globalStyles = {
  /** SECTION */

  section: {
    minWidth: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "10vh",
    paddingBottom: "10vh",
    paddingLeft: "10vw",
    paddingRight: "10vw",
  },
  mobileSection: {
    minWidth: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "5vh",
    paddingBottom: "5vh",
    paddingLeft: "5vw",
    paddingRight: "5vw",
  },
  fullHeightSection: {
    minHeight: "100vh",
  },
  halfHeightSection: {
    minHeight: "50vh",
  },
  darkBackground: {
    backgroundColor: constants.K_COLORS_DARK_NAVY,
  },
  lightBackground: {
    backgroundColor: constants.K_COLORS_LIGHT_GREY,
  },

  /** TEXT */
  spaced: {
    letterSpacing: "1.25px",
  },
  titleSpacing: {
    letterSpacing: "5px",
  },
  textMainSize: {
    fontSize: "5rem",
  },
  textLargeSize: {
    fontSize: "2.5rem",
  },
  textTitleSize: {
    fontSize: "1.75rem",
  },
  textNormalSize: {
    fontSize: "1.25rem",
  },
  textSmallSize: {
    fontSize: "1rem",
  },
  textSmallerSize: {
    fontSize: "0.75rem",
  },
  textDarkNavyColor: {
    color: constants.K_COLORS_DARK_NAVY,
  },
  textDarkGreyColor: {
    color: constants.K_COLORS_DARK_GREY,
  },
  textSmokeGreyColor: {
    color: constants.K_COLORS_SMOKE_GREY,
  },
  textLightGreyColor: {
    color: constants.K_COLORS_LIGHT_GREY,
  },
  textLightBlueColor: {
    color: constants.K_COLORS_LIGHT_BLUE,
  },
};

export default globalStyles;
